import { useQuery } from "@apollo/react-hooks";

import learners from "@hubcapp/graphql/learners.graphql";

import { Learner } from "@hubcapp/types";

const useQueryGetLearners = ({ instructorId }: { instructorId: string }) =>
  useQuery<{ instructor: { learners: Learner[] } }>(learners, {
    variables: { id: instructorId },
    fetchPolicy: "cache-first",
  });

export default useQueryGetLearners;
